"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MessageComment;

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _Tag = _interopRequireDefault(require("../Tag"));

var _MediaMosaic = _interopRequireDefault(require("../MediaMosaic"));

var _MenuButton = _interopRequireDefault(require("../MenuButton"));

var _TruncateWithShow = _interopRequireDefault(require("../TruncateWithShow"));

var _MessageSince = _interopRequireDefault(require("../MessageSince"));

var S = _interopRequireWildcard(require("./styled"));

function MessageComment(_ref) {
  var id = _ref.id,
      author = _ref.author,
      avatar = _ref.avatar,
      createdAt = _ref.createdAt,
      messageStatusLikes = _ref.messageStatusLikes,
      body = _ref.body,
      showMoreString = _ref.showMoreString,
      menuActions = _ref.menuActions,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      isCoach = _ref.isCoach,
      coachString = _ref.coachString;
  return /*#__PURE__*/_react["default"].createElement(S.Wrapper, {
    container: true,
    spacing: 2,
    wrap: "nowrap"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, avatar), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(S.Body, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(S.Author, null, author), isCoach && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_Tag["default"], {
    color: _colors["default"].liva[400]
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: "inherit",
    variant: "caption"
  }, coachString))), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_TruncateWithShow["default"], {
    showMoreString: showMoreString
  }, body)), media && media.length > 0 && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mt: 1,
    flex: 1
  }, /*#__PURE__*/_react["default"].createElement(_MediaMosaic["default"], {
    id: "".concat(id, "-media-mosaic"),
    media: media
  }))), /*#__PURE__*/_react["default"].createElement(S.LikeAndSince, {
    item: true,
    container: true,
    wrap: "nowrap",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, messageStatusLikes), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(S.Separator, {
    variant: "body2"
  }, "\u2022")), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_MessageSince["default"], {
    timeStamp: createdAt
  })))), menuActions && menuActions.length > 0 && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: "options-wrapper",
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_MenuButton["default"], {
    id: "".concat(id, "-menu-button")
  }, menuActions)));
}